// user_details_context.js

import { createContext, useContext } from 'react';

const UserDetailsContext = createContext();

export const useUserDetailsContext = () => {
  return useContext(UserDetailsContext);
};

export const UserDetailsProvider = ({ children }) => {
  // Implement your state and functions for user details here

  // Function to post user email to the database
  const postUserEmailToDatabase = async (email, name) => {
    try {
      // Implement your API call here (using fetch or axios)
      const response = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/api/user/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({username: name, email: email }),
      });
      const data = await response.json();
      // Handle response or errors
    } catch (error) {
      console.error('Error posting user email:', error);
      throw new Error('Failed to post user email to the database');
    }
  };

  return (
    <UserDetailsContext.Provider value={{ postUserEmailToDatabase }}>
      {children}
    </UserDetailsContext.Provider>
  );
};
